import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalPagesComponent } from './internal-pages.component';
import { InternalPagesRoutes } from './internal-pages.routes';
import { sharedModule } from '../shared/shared.module';import { MaterialModule } from "src/material/material.module";
import { MonthlyConsultationComponent } from './consultation/monthly-consultation/monthly-consultation.component';
import { TemplateVersionsComponent } from './management/template-versions/template-versions.component';
import { SaleKindVersionsComponent } from './management/sale-kind-versions/sale-kind-versions.component';

@NgModule({
    declarations: [
        InternalPagesComponent,
        MonthlyConsultationComponent,
        TemplateVersionsComponent,
        SaleKindVersionsComponent,
    ],
    imports: [
        CommonModule,
        sharedModule,
        InternalPagesRoutes,
        MaterialModule
    ],
    exports: [

    ]
})

export class InternalPagesModule {}
